const logoSlider = () => {
	const sliders = document.querySelectorAll(".slider-logos");
	sliders.forEach(slider => {
		// Prevent double initialization
		if (slider.querySelector(".slider-logos__track")) return;

		const originalChildren = Array.from(slider.children);
		// Ensure there are child element nodes to slide
		if (originalChildren.length === 0) return;

		const track = document.createElement("div");
		track.className = "slider-logos__track";

		// Move original children to the track
		originalChildren.forEach(child => track.appendChild(child));
		slider.appendChild(track);

		// Calculate how many repetitions we need to fill the viewport and scroll smoothly.
		// Estimated width of each item: 4rem (64px) gap + ~150px average logo width = ~214px
		const estimatedItemWidth = 214;
		const originalWidth = originalChildren.length * estimatedItemWidth;

		// We want the track to be at least 1.5 times the viewport width, and at least 2500px wide.
		const targetWidth = Math.max(window.innerWidth * 1.5, 2500);

		// Repetitions needed based on width
		const repetitionsByWidth = Math.ceil(targetWidth / originalWidth);

		// Repetitions needed to have at least 15 items in the track
		const repetitionsByCount = Math.ceil(15 / originalChildren.length);

		// We take the maximum of both to ensure both conditions are satisfied
		const totalRepetitions = Math.max(repetitionsByWidth, repetitionsByCount);

		// Since we already put the 1st repetition in the track, we append (totalRepetitions - 1) clones
		for (let i = 1; i < totalRepetitions; i++) {
			originalChildren.forEach(child => {
				const clone = child.cloneNode(true);
				track.appendChild(clone);
			});
		}

		// Clone the entire track once and append to slider
		const clone = track.cloneNode(true);
		slider.appendChild(clone);
	});
};

export { logoSlider };
